export default __webpack_public_path__ + "static/media/file.922ccf97.svg";